/**
 * Права страниц: {view, edit, admin}. Список admin появился позже — у старых
 * пользователей его в JSON нет, поэтому по умолчанию пустой.
 */
export function parseUserPermissions(permissionsRaw) {
  if (!permissionsRaw) return { view: [], edit: [], admin: [] };
  try {
    const p = typeof permissionsRaw === 'string' ? JSON.parse(permissionsRaw) : permissionsRaw;
    return {
      view: Array.isArray(p.view) ? p.view : [],
      edit: Array.isArray(p.edit) ? p.edit : [],
      admin: Array.isArray(p.admin) ? p.admin : [],
    };
  } catch {
    return { view: [], edit: [], admin: [] };
  }
}
